import * as React from 'react';
import { SIMPLIFY_COLORS } from '../../../../constants/colors';
import { FC } from 'react';
import { IIconProps } from '../../types';

export const ArrowUpRight12: FC<IIconProps> = props => {
  const { color: _color } = props;

  const color = _color ? SIMPLIFY_COLORS[_color] : SIMPLIFY_COLORS.primary;

  return (
    // oxlint-disable-next-line react/forbid-elements
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.92 6.6197C17.8186 6.37547 17.6245 6.18139 17.3803 6.07996C17.2601 6.02875 17.1311 6.00158 17.0005 6H7.00531C6.74022 6 6.48599 6.10531 6.29855 6.29275C6.1111 6.4802 6.0058 6.73443 6.0058 6.99952C6.0058 7.26461 6.1111 7.51884 6.29855 7.70628C6.48599 7.89373 6.74022 7.99903 7.00531 7.99903H14.5916L6.29566 16.285C6.20197 16.3779 6.12761 16.4885 6.07687 16.6103C6.02613 16.7321 6 16.8627 6 16.9947C6 17.1266 6.02613 17.2573 6.07687 17.3791C6.12761 17.5009 6.20197 17.6114 6.29566 17.7043C6.38857 17.798 6.49912 17.8724 6.62092 17.9231C6.74272 17.9739 6.87336 18 7.00531 18C7.13726 18 7.2679 17.9739 7.3897 17.9231C7.5115 17.8724 7.62205 17.798 7.71497 17.7043L16.001 9.40835V16.9947C16.001 17.2598 16.1063 17.514 16.2937 17.7015C16.4812 17.8889 16.7354 17.9942 17.0005 17.9942C17.2656 17.9942 17.5198 17.8889 17.7072 17.7015C17.8947 17.514 18 17.2598 18 16.9947V6.99952C17.9984 6.8689 17.9713 6.73986 17.92 6.6197Z"
        fill={color}
      />
    </svg>
  );
};
